const en = {
    common: {
        cancel: 'Cancel',
        close: 'Close',
        goBack: 'Go back',
        settings: 'Settings',
        signOut: 'Sign out',
        ok: 'OK',
        loading: 'Loading…',
        tryAgain: 'Try again',
        offline: 'Offline'
    },
    loading: {
        ariaLabel: 'Loading'
    },
    login: {
        title: 'Sign in to 7punches',
        subtitle: 'Please use your 7shifts login',
        signIn: 'Sign in',
        redirecting: 'Redirecting…',
        errorFallback: 'Unable to start sign-in'
    },
    callback: {
        failed: 'Sign-in failed',
        tryAgain: 'Try again'
    },
    selection: {
        title: 'Select your location',
        companyLabel: 'Company',
        companyPlaceholder: 'Select a company',
        locationLabel: 'Location',
        locationPlaceholder: 'Select a location',
        next: 'Next'
    },
    footer: {
        poweredBy: 'Powered by 7shifts'
    },
    pinGrid: {
        title: 'Enter your Punch ID',
        clear: 'CLEAR',
        backspace: 'Backspace',
        punch: 'Punch',
        srNoDigits: 'No digits entered',
        srDigitCountSingular: '1 digit entered',
        srDigitCountPlural: '{count} digits entered'
    },
    tips: {
        title: 'Enter Tips',
        subtitle: 'How much did you earn in tips this shift?',
        amountLabel: 'Tip amount',
        validationError: 'Please enter a valid tip amount.',
        submit: 'Submit',
        confirm: 'Confirm',
        skip: 'Skip',
        keypadAriaLabel: 'Tip amount keypad'
    },
    department: {
        title: 'Select a department'
    },
    role: {
        selectTitle: 'Select a role',
        confirmTitle: 'Confirm your role'
    },
    attestation: {
        confirm: 'Confirm'
    },
    healthCheck: {
        unavailableTitle: 'Health Check Unavailable',
        unavailableBody:
            "We couldn't load the health check questions. Please try again or cancel.",
        dismiss: 'Dismiss',
        submitFallback: 'Submit'
    },
    punchResult: {
        clockIn: {
            heading: 'Punched in!',
            subtitle: 'Welcome, {name}!'
        },
        clockOut: {
            heading: 'Punched out!',
            subtitle: 'See you later, {name}!'
        },
        breakStart: {
            heading: 'Break started',
            subtitle: 'Enjoy your break, {name}!'
        },
        breakEnd: {
            heading: 'Welcome back!',
            subtitle: "Let's get back to it, {name}!"
        },
        ok: 'OK ({countdown})'
    },
    offlinePunchRecorded: {
        title: 'Offline punch recorded',
        subtitle: "We'll automatically sync this once you're back online.",
        ok: 'OK ({countdown})'
    },
    error: {
        defaultHeader: 'Something went wrong',
        invalidPunchId: {
            header: 'Incorrect Punch ID',
            body: 'Please try again.'
        },
        breakTooShort: {
            header: 'Back too soon',
            body: "Your break hasn't reached the minimum length yet."
        },
        healthCheckFailed: {
            header: 'Unable to punch in due to health screening',
            body: 'Based on your responses, you are unable to complete your shift. Please contact your manager.'
        },
        notAssignedToLocation: {
            header: "You're not assigned to this location",
            body: 'Please contact your manager to be scheduled here before punching in.'
        },
        clockInTooEarly: {
            header: 'Too early to punch in',
            body: "You can't punch in yet. Please try again closer to your shift start time."
        },
        shiftNotScheduled: {
            header: 'Not scheduled to work',
            body: "It looks like you aren't scheduled today. Please contact your manager."
        },
        network: {
            header: 'No Connection',
            body: "Can't connect to 7shifts.com. Please check your internet connection and try again."
        },
        serverOrUnknown: {
            header: 'Something went wrong',
            body: 'An unknown error has occurred. Please try again.'
        }
    },
    userStatus: {
        greeting: 'Hi, {firstName}!',
        haveAGreatShift: 'Have a great shift today.',
        yourShifts: 'Your shifts',
        currentShift: 'Current shift',
        punchedIn: 'Punched-in',
        onBreak: 'On-break',
        timeOnShift: 'time on shift',
        onBreakElapsed: '{elapsed} on break',
        breakEndsAt: 'ends at {time}',
        noScheduledShifts: 'No scheduled shifts',
        noShiftsToday: 'You have no shifts today.'
    },
    account: {
        noCompanies: 'No companies found for this account.',
        failedToLoadCompanies: 'Failed to load companies.',
        noLocations: 'No locations found for this company.',
        failedToLoadLocations: 'Failed to load locations.',
        failedToLoadAccount: 'Failed to load account.'
    },
    settings: {
        changeLocation: 'Change Location',
        logout: 'Logout',
        theme: 'Theme',
        themeLight: 'Light',
        themeDark: 'Dark',
        themeUrlLocked: 'Theme was initially set by the URL parameter.',
        verifyLogoutTitle: 'Confirm logout',
        verifyLogoutSubmit: 'Log out',
        verifyChangeLocationTitle: 'Confirm location change',
        verifyChangeLocationSubmit: 'Change location',
        verifyError: 'Incorrect Punch ID. Please try again.'
    },
    inactivity: {
        title: 'Still there?',
        subtitle: "You haven't tapped anywhere for a while.",
        stayActive: "I'm still here!",
        signOut: 'Sign out',
        signOutCountdown: 'Sign out ({countdown})'
    },
    sessionExpired: {
        title: 'Session expired',
        message:
            "You've been logged out due to inactivity. Please sign in again.",
        messageWebview:
            "You've been logged out due to inactivity. Please use the app to sign in again."
    },
    externalUser: {
        signingIn: 'Signing you in…',
        done: "You're all set!"
    },
    offline: {
        banner: {
            heading: 'No internet connection',
            body: "You can still punch in and out, but other features are limited until you're back online.",
            timeLimitPrefix: 'You can punch offline for ',
            daysSingular: '1 more day',
            daysPlural: '{count} more days',
            timeLimitSuffix:
                '. Please reconnect soon to keep using the time clock.'
        },
        lockout: {
            heading: 'Offline limit reached',
            body: "You can't punch in or out until this device is reconnected to the internet."
        },
        intermediate: {
            greeting: 'Hi!',
            haveAGreatShift: 'Have a great shift today.',
            heading: "You're offline",
            body: "You can still punch in and out. We'll sync your punches as soon as you're back online.",
            punchButton: 'Punch offline'
        }
    }
} as const;

export default en;
